// Components
import { Table, TableFilter } from '../../components';

// Constants
import { SECTION_LIST_ENUM, STATUS_ENUM } from './constants';

// Actions
import { fetchUpdatingMerchantRequest } from './redux/MerchantOnboardStatus.actions';

// Libraries
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment().subtract(1, 'days'),
            endDate: moment(),
            maximumNights: 6,
            notResetDate: true,
        },
    },
    {
        fieldType: 'select',
        label: 'Merchant Name / Merchant ID',
        name: 'entityCode',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
    {
        fieldType: 'select',
        label: 'Select state',
        name: 'state',
        props: {
            data: STATUS_ENUM,
            label: 'Select State',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'select',
        label: 'Select Section',
        name: 'sectionType',
        id: 'sectionType',
        props: {
            data: SECTION_LIST_ENUM,
            label: 'Select Section',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'checkbox',
        label: 'Updated By',
        name: 'updatedBy',
        props: {
            options: [
                {
                    name: 'Updated by me',
                    value: 'SUCCESS',
                },
            ],
            labelField: 'name',
            valueField: 'value',
        },
    },
];

const setMerchantFilter = (fieldsList, underlyingMerchant) => {
    if (underlyingMerchant.length) {
        fieldsList.forEach(element => {
            if (element.name === 'entityCode') {
                element.props.data = underlyingMerchant;
            }
        });
        return fieldsList;
    }
    return fieldsList.filter(item => item.name !== 'entityCode');
};

const MerchantOnboardStatusTable = props => {
    const [filterData, setFilterData] = useState({});
    const [isResetPage, setIsResetPage] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const pageSizeOptions = [10, 20, 40, 60];

    const {
        staticData,
        merchantOnBoardStatusData,
        actions,
        loader: { showLoader },
        auth,
    } = props;

    const {
        error,
        tableData,
        isLoading,
        pagination,
    } = merchantOnBoardStatusData;

    const { underlyingMerchant } = staticData;
    const filters = setMerchantFilter(filterFieldList, underlyingMerchant);

    const columns = useMemo(
        () => [
            { header: 'Entity Code', accessor: 'entityCode' },
            { header: 'Entity Type', accessor: 'entityType' },
            { header: 'Update status', accessor: 'state' },
            { header: 'Section Type', accessor: 'sectionType' },
            { header: 'Updated By', accessor: 'userId' },
            { header: 'Status Message', accessor: 'statusMessage' },
        ],
        []
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageIndex,
            };
            actions.fetchUpdatingMerchantRequest({
                ...data,
                ...filterData,
                userEmailId: auth.userDetails.email,
            });
            setPageSize(pageSize);
        },
        [actions, auth.userDetails.email, filterData]
    );

    return (
        <>
            <Table
                id="merchant-edit"
                tableTitle="Merchant Update History"
                filterActionTitle=""
                columns={columns}
                data={tableData}
                fetchData={fetchData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                isFiltersEnable
                isPaginationEnable
                tableFilters={
                    <TableFilter
                        showOverlay
                        customFilterClass="rightSkewed"
                        fieldsList={filters}
                        filterData={filterData}
                        onSubmit={filterValues => {
                            setFilterData({ ...filterValues });
                            setIsResetPage(true);
                        }}
                        onReset={resetValue => {
                            setFilterData(resetValue);
                            setIsResetPage(true);
                        }}
                    />
                }
            />
        </>
    );
};

MerchantOnboardStatusTable.propTypes = {
    staticData: PropTypes.object,
    merchantOnBoardStatusData: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
    loader: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    merchantOnBoardStatusData,
    loader,
    staticData,
}) => ({
    auth,
    merchantOnBoardStatusData,
    loader,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchUpdatingMerchantRequest,
        },
        dispatch
    ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MerchantOnboardStatusTable);
